import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  raffles: [
    {
      id: 2,
      title: "Music Festival",
      createdon: "2023-05-15",
      purpose: "Celebrating local artists",
      totalTickets: 500,
      ticketPrice: 25.99,
      monetaryAward: "Best Performer Prize",
      ticketSold: 420,
      earned: 10956.8,
      winner: "The Band XYZ",
      winningDate: "2023-06-10",
      visible: true,
    },
    {
      id: 3,
      title: "Art Exhibition",
      createdon: "2023-02-28",
      purpose: "Showcasing modern art",
      totalTickets: 300,
      ticketPrice: 15.5,
      monetaryAward: "Best in Show",
      ticketSold: 280,
      earned: 4340,
      winner: "Artist ABC",
      winningDate: "2023-03-30",
      visible: true,
    },
    {
      id: 4,
      title: "Science Fair",
      createdon: "2023-08-10",
      purpose: "Encouraging scientific inquiry",
      totalTickets: 150,
      ticketPrice: 10,
      monetaryAward: "Innovation Award",
      ticketSold: 120,
      earned: 1200,
      winner: "Student X",
      winningDate: "2023-09-15",
      visible: true,
    },
    {
      id: 5,
      title: "Film Screening",
      createdon: "2023-04-20",
      purpose: "Showcasing independent films",
      totalTickets: 200,
      ticketPrice: 12.5,
      monetaryAward: "Best Director",
      ticketSold: 180,
      earned: 2250,
      winner: "Director PQR",
      winningDate: "2023-05-25",
      visible: true,
    },
    {
      id: 6,
      title: "Charity Gala",
      createdon: "2023-09-05",
      purpose: "Raising funds for local hospital",
      totalTickets: 1000,
      ticketPrice: 50,
      monetaryAward: "Philanthropy Award",
      ticketSold: 800,
      earned: 40000,
      winner: "Top Donor Group",
      winningDate: "2023-10-15",
      visible: true,
    },
    {
      id: 7,
      title: "Fashion Show",
      createdon: "2023-06-12",
      purpose: "Showcasing seasonal trends",
      totalTickets: 400,
      ticketPrice: 30,
      monetaryAward: "Best Designer",
      ticketSold: 350,
      earned: 10500,
      winner: "Designer LMN",
      winningDate: "2023-07-20",
      visible: true,
    },
    {
      id: 8,
      title: "Food Festival",
      createdon: "2023-07-25",
      purpose: "Celebrating culinary diversity",
      totalTickets: 600,
      ticketPrice: 20,
      monetaryAward: "Best Dish",
      ticketSold: 550,
      earned: 11000,
      winner: "Chef XYZ",
      winningDate: "2023-08-30",
      visible: true,
    },
    {
      id: 9,
      title: "Food Festival",
      createdon: "2023-07-25",
      purpose: "Celebrating culinary diversity",
      totalTickets: 600,
      ticketPrice: 20,
      monetaryAward: "Best Dish",
      ticketSold: 550,
      earned: 11000,
      winner: "Chef XYZ",
      winningDate: "2023-08-30",
      visible: true,
    },
    {
      id: 10,
      title: "Food Festival",
      createdon: "2023-07-25",
      purpose: "Celebrating culinary diversity",
      totalTickets: 600,
      ticketPrice: 20,
      monetaryAward: "Best Dish",
      ticketSold: 550,
      earned: 11000,
      winner: "Chef XYZ",
      winningDate: "2023-08-30",
      visible: true,
    },
    {
      id: 11,
      title: "Food Festival",
      createdon: "2023-07-25",
      purpose: "Celebrating culinary diversity",
      totalTickets: 600,
      ticketPrice: 20,
      monetaryAward: "Best Dish",
      ticketSold: 550,
      earned: 11000,
      winner: "Chef XYZ",
      winningDate: "2023-08-30",
      visible: true,
    },
    {
      id: 12,
      title: "Food Festival",
      createdon: "2023-07-25",
      purpose: "Celebrating culinary diversity",
      totalTickets: 600,
      ticketPrice: 20,
      monetaryAward: "Best Dish",
      ticketSold: 550,
      earned: 11000,
      winner: "Chef XYZ",
      winningDate: "2023-08-30",
      visible: true,
    },
    {
      id: 13,
      title: "Food Festival",
      createdon: "2023-07-25",
      purpose: "Celebrating culinary diversity",
      totalTickets: 600,
      ticketPrice: 20,
      monetaryAward: "Best Dish",
      ticketSold: 550,
      earned: 11000,
      winner: "Chef XYZ",
      winningDate: "2023-08-30",
      visible: true,
    },
    {
      id: 14,
      title: "Food Festival",
      createdon: "2023-07-25",
      purpose: "Celebrating culinary diversity",
      totalTickets: 600,
      ticketPrice: 20,
      monetaryAward: "Best Dish",
      ticketSold: 550,
      earned: 11000,
      winner: "Chef XYZ",
      winningDate: "2023-08-30",
      visible: true,
    },
  ],
  editingRaffle: null,
  filter: "all",
};

const rafflesSlice = createSlice({
  name: "raffles",
  initialState,
  reducers: {
    addRaffle: (state, action) => {
      const id = state.raffles.length
        ? state.raffles[state.raffles.length - 1].id + 1
        : 1;
      state.raffles.push({ id, ...action.payload, visible: true });
    },
    editRaffle: (state, action) => {
      const index = state.raffles.findIndex(
        (raffle) => raffle.id === action.payload.id
      );
      if (index !== -1) {
        state.raffles[index] = { ...state.raffles[index], ...action.payload };
      }
    },
    deleteRaffle: (state, action) => {
      state.raffles = state.raffles.filter(
        (raffle) => raffle.id !== action.payload
      );
    },
    toggleVisibility: (state, action) => {
      const index = state.raffles.findIndex(
        (raffle) => raffle.id === action.payload
      );
      if (index !== -1) {
        state.raffles[index].visible = !state.raffles[index].visible;
      }
    },
    setEditingRaffle: (state, action) => {
      state.editingRaffle = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
  },
});

export const {
  addRaffle,
  editRaffle,
  deleteRaffle,
  toggleVisibility,
  setEditingRaffle,
  setFilter,
} = rafflesSlice.actions;

export default rafflesSlice.reducer;
